// @mui
import Grid from '@mui/material/Unstable_Grid2';
// types

import { IPaymentCard } from '../../../../types/payment';
import { IAddressItem } from '../../../../types/address';
import AccountBillingHistory from './account-billing-history';
import AccountBillingAddress from './account-billing-address';
import { IUserAccountBillingHistory } from '../../../../types/user';
import AccountBillingPaymentByCard from './account-billing-payment-by-card';
//
import AccountBillingPayment from './account-billing-payment';

// ----------------------------------------------------------------------

type Props = {
  plans: {
    subscription: string;
    price: number;
    primary: boolean;
  }[];
  cards: IPaymentCard[];
  invoices: IUserAccountBillingHistory[];
  addressBook: IAddressItem[];
};

export default function AccountBilling({ cards, plans, invoices, addressBook }: Props) {
  return (
    <Grid container spacing={5} disableEqualOverflow>
      <Grid xs={12} md={8}>
        {/* <AccountBillingPlan plans={plans} cardList={cards} addressBook={addressBook} /> */}

        <AccountBillingPaymentByCard cards={cards} />

        <AccountBillingPayment cards={cards} />

        <AccountBillingAddress addressBook={addressBook} />
      </Grid>

      <Grid xs={12} md={4}>
        <AccountBillingHistory invoices={invoices} />
      </Grid>
    </Grid>
  );
}
